import { useFormik } from "formik";
import InputField from "shared/InputField";
import { createProfileValidationSchema } from "validation/ngo/profile/createProfile1Schema";

const NGOdetails = ({ next, setBody }) => {
  const formik = useFormik({
    initialValues: {
      name: "",
      about: "",
      statement_of_purpose: "",
    },
    validationSchema: createProfileValidationSchema,
    onSubmit: (values) => {
      const body = {
        name: values.name,
        about: values.about,
        statement_of_purpose: values.statement_of_purpose,
      };
      setBody(body);
      next();
    },
  });

  return (
    <div className="flex flex-col gap-y-4 px-8">
      <div className="flex items-center mt-8 mb-4 justify-center">
        <p className="font-bold text-[18px]">NGO Information</p>
      </div>
      <div className="flex items-center justify-center">
        <p className="text-[#7A7A7A] text-[14px]">
          Please provide the following details
        </p>
      </div>
      <div className="flex flex-1 justify-center items-center">
        <form
          onSubmit={formik.handleSubmit}
          className="w-full flex flex-col gap-y-4"
        >
          <div className="flex flex-col gap-2">
            <label className="text-[14px] font-normal">Name of NGO</label>
            <InputField
              className="border border-[#E6E6E6] rounded-md"
              type="text"
              name="name"
              id="name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
            />
            {formik.touched.name && formik.errors.name ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.name}
              </p>
            ) : null}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-[14px] font-normal">About Your NGO</label>
            <textarea
              className="px-4 py-2 outline-none bg-white border border-[#E6E6E6] rounded-md placeholder:text-[14px]"
              rows="5"
              name="about"
              placeholder="Please provide the following details"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.about}
            />
            {formik.touched.about && formik.errors.about ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.about}
              </p>
            ) : null}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-[14px] font-normal">
              Statement Of Purpose
            </label>
            <textarea
              className="px-4 py-2 outline-none bg-white border border-[#E6E6E6] rounded-md placeholder:text-[14px]"
              rows="5"
              name="statement_of_purpose"
              placeholder="Short description of your mission and vision"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.statement_of_purpose}
            />
            {formik.touched.statement_of_purpose &&
            formik.errors.statement_of_purpose ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.statement_of_purpose}
              </p>
            ) : null}
          </div>
          <button
            type="submit"
            className="bg-[#213874] text-white py-2 rounded-md"
          >
            Next
          </button>
        </form>
      </div>
    </div>
  );
};

export default NGOdetails;
